export default class DebugPerformance {


    // console if larger than 50 ms
    static profiler50(
        id : any, // the "id" prop of the Profiler tree that has just committed
        phase : any, // either "mount" (if the tree just mounted) or "update" (if it re-rendered)
        actualDuration : any, // time spent rendering the committed update
        baseDuration : any, // estimated time to render the entire subtree without memoization
        startTime : any, // when React began rendering this update
        commitTime : any, // when React committed this update
        interactions : any // the Set of interactions belonging to this update
    ) {
        if (actualDuration>50) {
            // @ts-ignore
            console.green("⏰ ", id, phase, Math.ceil(actualDuration))
        }
    }

    static profiler(
        id : any, // the "id" prop of the Profiler tree that has just committed
        phase : any, // either "mount" (if the tree just mounted) or "update" (if it re-rendered)
        actualDuration : any, // time spent rendering the committed update
        baseDuration : any, // estimated time to render the entire subtree without memoization
        startTime : any, // when React began rendering this update
        commitTime : any, // when React committed this update
        interactions : any // the Set of interactions belonging to this update
    ) {
        // @ts-ignore
        console.green("⏰ ", id, phase, actualDuration)
    }

    static start(label : any) {
        // @ts-ignore
        window.performance[label] = Date.now()
        // console.log("start", window.performance[label])
    }


    static stop(label:string, tabs=0) {


        // @ts-ignore
        const duration = Date.now() - window.performance[label]

        const tabsString = " ".repeat(tabs * 4)

        // console.log(label, 'duration =', duration)
        // ← ↑ → ↓
        // @ts-ignore
        console.purple(tabsString + "⏳ " +label + ': ' +duration)

        // @ts-ignore
        delete window.performance[label]




    }

}